var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#516EAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H13C8 26 6 24 6 19V13C6 8 8 6 13 6H19C24 6 26 8 26 13V19C26 24 24 26 19 26Z",
    stroke: "#516EAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3V16.2H20.6C20.8 16.2 20.9 16.4 20.9 16.6L20.5 18.5C20.5 18.6 20.3 18.7 20.2 18.7H18V26H15V18.8H13.3C13.1 18.8 13 18.7 13 18.5V16.6C13 16.4 13.1 16.3 13.3 16.3H15V13C15 11.3 16.3 10 18 10H20.7C20.9 10 21 10.1 21 10.3V12.7C21 12.9 20.9 13 20.7 13H18.3C18.1 13 18 13.1 18 13.3Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.570642132898aa2903d5ad72f2642734.svg";
export { ForwardRef as ReactComponent };